import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ThemeProvider } from './contexts/ThemeContext';
import { SupabaseProvider } from './contexts/SupabaseContext';
import { registerChunkLoadRecovery } from './lib/chunkLoadRecovery';

registerChunkLoadRecovery();

function mountMobileDebugConsole() {
  if (!import.meta.env.DEV || typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  if (params.get('eruda') !== '1') return;

  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/eruda';
  script.onload = () => {
    const eruda = (window as Window & { eruda?: { init: () => void } }).eruda;
    eruda?.init();
  };
  document.body.appendChild(script);
}

mountMobileDebugConsole();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SupabaseProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </SupabaseProvider>
  </StrictMode>
);
